import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().email('Email inválido'),
    password: z.string().min(1, 'La contraseña es requerida'),
});
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, 'La contraseña actual es requerida'),
    newPassword: z
        .string()
        .min(8, 'La contraseña debe tener al menos 8 caracteres')
        .regex(/[A-Z]/, 'Debe contener al menos una mayúscula')
        .regex(/[0-9]/, 'Debe contener al menos un número'),
    confirmPassword: z.string().min(1, 'Confirma la contraseña'),
})
    .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Las contraseñas no coinciden',
    path: ['confirmPassword'],
})
    .refine((data) => data.newPassword !== data.currentPassword, {
    message: 'La nueva contraseña no puede ser igual a la actual',
    path: ['newPassword'],
});
export const refreshTokenSchema = z.object({
    refreshToken: z.string().min(1, 'El token de refresco es requerido'),
});
//# sourceMappingURL=auth.schema.js.map